<div class="container-fluid py-3">
  <div class="row">

    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>

    <div class="col-12 rounded bg-white py-3 mb-3">
      <div class="row align-items-end px-2 g-2">

        <div class="col-auto">
          <label class="form-label mb-1">
            <small><b class="text-secondary">Desde</b></small>
          </label>
          <div class="input-group">
            <input
              #dpFromDate
              class="form-control"
              style="max-width: 130px;"
              placeholder="yyyy-mm-dd"
              name="dpFromDate"
              [value]="formatter.format(fromDate)"
              (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
              readonly
            />
            <button
              class="btn btn-outline-secondary d-flex align-items-center"
              (click)="datepicker.toggle()"
              type="button"
              aria-label="Abrir calendario"
            >
              <i class="material-icons" style="font-size: 1.1rem;">calendar_month</i>
            </button>
          </div>
          <!-- Input invisible DESPUÉS del input-group: su top coincide con el fondo del campo visible -->
          <input
            name="datepicker"
            style="display: block; width: 100%; height: 0; padding: 0; border: 0; overflow: hidden; opacity: 0; pointer-events: none;"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [container]="'body'"
            [placement]="'bottom-start'"
            [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="2"
            [dayTemplate]="t"
            outsideDays="hidden"
            [startDate]="fromDate!"
            tabindex="-1"
            readonly
          />
        </div>

        <div class="col-auto">
          <label class="form-label mb-1">
            <small><b class="text-secondary">Hasta</b></small>
          </label>
          <div class="input-group">
            <input
              #dpToDate
              class="form-control"
              style="max-width: 130px;"
              placeholder="yyyy-mm-dd"
              name="dpToDate"
              [value]="formatter.format(toDate)"
              (input)="toDate = validateInput(toDate, dpToDate.value)"
              readonly
            />
            <button
              class="btn btn-outline-secondary d-flex align-items-center"
              (click)="datepicker.toggle()"
              type="button"
              aria-label="Abrir calendario"
            >
              <i class="material-icons" style="font-size: 1.1rem;">calendar_month</i>
            </button>
          </div>
        </div>

        <div class="col-auto ms-auto">
          <button
            (click)="getData()"
            class="btn btn-primary rounded-circle"
            ngbTooltip="Actualizar"
            aria-label="Actualizar"
          >
            <i class="material-icons mt-1">refresh</i>
          </button>
        </div>

      </div>
    </div>

  </div>
</div>

<ul ngbNav #nav="ngbNav" class="nav-pills pt-3">
  @for(key of getKeys(passesResponse); track $index) {

    <li ngbNavItem>
      <button ngbNavLink>
        {{ getTitle(key) }} {{ passesResponse[key].length || 0 }}
      </button>
      <ng-template ngbNavContent>

        <div class="container-fluid">
          <div class="row pt-3">

            <app-passes-page
              [visits]="passesResponse[key]"
              [loading]="false">
            </app-passes-page>

          </div>
        </div>

      </ng-template>
    </li>

  }
</ul>
<div [ngbNavOutlet]="nav"></div>
